import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import PropTypes from "prop-types";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";

const RequestTypesSummary = ({ requestType, visible, onBackClick, onEvidencesChanged, error }) => {
    const [evidenceDocTypes, setEvidenceDocTypes] = useState([]);

    useEffect(() => {
        if (requestType?.evidenceDocTypes) {
            setEvidenceDocTypes(requestType.evidenceDocTypes);
        }
        return () => {
            setEvidenceDocTypes([]);
        };
    }, [requestType]);

    function onSelectedChanged(selectedIds) {
        const filteredEvidenceDocTypes = evidenceDocTypes.filter((docType) => selectedIds.includes(docType.id));
        onEvidencesChanged(filteredEvidenceDocTypes);
    }

    return (
        <div
            className={clsx("layout request-types-summary-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && requestType && (
                <>
                    <h3>Type</h3>
                    <Card>
                        <div>
                            <span>{requestType?.type}</span>
                        </div>
                        <Button secondary link onClick={onBackClick}>
                            <Icon name="cancel" color="secondary" size="xs" />
                        </Button>
                    </Card>
                    <EnhancedTable
                        headCells={[
                            { index: 1, id: "cocEvidenceDocType.type", label: "Evidences" },
                            {
                                index: 2,
                                id: "descriptionOverride",
                                label: "",
                            },
                        ]}
                        data={evidenceDocTypes}
                        selectable={true}
                        pageable={false}
                        filterable={false}
                        deletable={false}
                        orderable={false}
                        keyColumnName="id"
                        onRequestData={() => evidenceDocTypes}
                        onSelectedChanged={onSelectedChanged}
                    />
                    {error && <div className="wizard-error">{error}</div>}
                </>
            )}
        </div>
    );
};

RequestTypesSummary.propTypes = {
    requestType: PropTypes.object,
    visible: PropTypes.bool,
    onBackClick: PropTypes.func,
    onEvidencesChanged: PropTypes.func,
    error: PropTypes.string,
};

RequestTypesSummary.defaultProps = {
    requestType: undefined,
    visible: true,
    onBackClick: () => {},
    onEvidencesChanged: () => {},
    error: undefined,
};

export default RequestTypesSummary;
